<script setup>
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import SalesTransactionDocumentsAPI from 'dashboard/api/salesTransactionDocuments';

const props = defineProps({
  documents: { type: Array, default: () => [] },
  transactionId: { type: [String, Number], default: null },
});

const { t } = useI18n();
const notify = useAlert;
const documentTypeLabel = document => {
  const types = document.document_types
    ?.map(type => type.name || type.nome || type.nome_tipo || type)
    .filter(Boolean);
  return types?.join(', ') || t('NUCLEO_WORK_ORDERS.DETAIL.DOCUMENTS.UNKNOWN');
};

const download = async document => {
  try {
    const response = await SalesTransactionDocumentsAPI.signedUrl(
      props.transactionId,
      document.id
    );
    window.open(response.data.data.url, '_blank', 'noopener,noreferrer');
  } catch (error) {
    notify(
      error?.response?.data?.message ||
        t('NUCLEO_WORK_ORDERS.DETAIL.DOCUMENTS.PROPERTY_DOWNLOAD_ERROR')
    );
  }
};
</script>

<template>
  <template v-if="documents.length">
    <section data-test="property-documents" class="grid gap-2">
      <button
        v-for="document in documents"
        :key="document.id"
        type="button"
        data-test="property-document-view"
        class="flex items-center justify-between gap-3 rounded-lais-sm bg-lais-bg-soft px-3 py-2 text-left text-sm text-lais-link hover:bg-lais-primary-50"
        @click="download(document)"
      >
        <span class="min-w-0 truncate">
          <span class="block text-xs text-lais-text-muted">
            {{ documentTypeLabel(document) }}
          </span>
          <span class="block truncate">{{ document.filename }}</span>
        </span>
        <span class="i-lucide-download size-4 shrink-0" aria-hidden="true" />
      </button>
    </section>
  </template>
  <template v-else />
</template>
